import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconImages4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconImages4"><Path fillRule="evenodd" clipRule="evenodd" d="M9 3C7.067 3 5.5 4.567 5.5 6.5C5.5 8.433 7.067 10 9 10C10.933 10 12.5 8.433 12.5 6.5C12.5 4.567 10.933 3 9 3ZM7.5 6.5C7.5 5.67157 8.17157 5 9 5C9.82843 5 10.5 5.67157 10.5 6.5C10.5 7.32843 9.82843 8 9 8C8.17157 8 7.5 7.32843 7.5 6.5Z" fill="currentColor"/><Path d="M15.0701 6.94238L23.032 19.9998H0.902344L6.73427 11.0804L10.2715 13.6071L15.0701 6.94238Z" fill="currentColor"/></CentralIconBase>;
});

export default IconImages4;
